module.exports = __webpack_public_path__ + "static/img/1-1.2e372a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/1-1.png
// module id = lqpQ
// module chunks = 0